export default {
  dataIterator: {
    rowsPerPageText: '每頁記錄數：',
    rowsPerPageAll: '全部',
    pageText: '{0}-{1} 共 {2} 條',
    noResultsText: '沒有找到匹配記錄',
    nextPage: '下一頁',
    prevPage: '上一頁'
  },
  dataTable: {
    rowsPerPageText: '每頁行數：'
  },
  noDataText: '沒有數據',
  carousel: {
    prev: '上一頁',
    next: '下一頁'
  },
  errors: {
    codeIncorrect: '驗證碼不正確',
    errorLogin: '登陸出錯',
    qr: {
      notAllowed: '出錯: 請允許打開攝像頭的權限',
      notFound: '出錯: 攝像頭無法打開',
      notSupported: '出錯: 請在安全的登錄環境試用(HTTPS)',
      notReadable: '出錯: 攝像頭已經在使用？ ',
      overConstrained: '出錯: 攝像頭不可用',
      streamAPINotSupported: '出錯: 流媒體API在本瀏覽器不可用',
      scanFailed: '二維碼無效',
      tableNumberFailed: '桌號無效'
    },
    location: {
      inStoreTitle: '當前位置不在門店內',
      inStoreDescription: '抱歉，您的當前位置不在門店內，無法進行掃碼點餐，請選擇自取或者外賣功能',
      inStoreBtn: '確認',
      locationDisabledTitle: '需允許手機定位功能',
      locationDescription: '請重新掃碼，選擇允許定位功能。或者在手機設置中打開定位',
      locationBtn: 'OK'
    },
    cart: {
      menuUnavailable: '當前時段無法下單',
      startShopping: '開始購物'
    },
    schedule: {
      availableTimes: '{0}開放時間為 {1} - {2}',
      unavailableTimes: '{0} 不開放的時間段為 {1} - {2}',
      availableDay: '{0}將在 {1}{2}開放',
      unavailable: '{0}當前關閉，請嘗試其他訂單類型',
      startScheduling: '您可以在 {0}{1}後開始預訂下單'
    },
    paymentUnsuccessful: '付款失敗',
    temporarilyAppear: '這筆費用可能會暫時顯示在您的對帳單上，然後再刪除',
    pageNotFound: '找不到頁面',
    storeNotFoundMessage: '您要找的商店找不到。它可能已被移動、刪除或URL不正確。'
  },
  common: {
    storeHoursClosedHoliday: "休息",
    today: '今天',
    nextAvailable: '下次可用',
    referralButtonText: '邀请您的朋友',
    pointsEarned: '獲得積分',
    confirmTitle: '请确认',
    confirmDesc: '您确定想要从堂食切换到自取下单？',
    actionText: '是的，切换',
    pickup: '自取',
    delivery: '配送',
    availableToDeliver: '可配送',
    notAvailableForDelivery: '不可配送',
    loginDescription: '立即註冊或登入，解鎖專屬優惠券、獎勵以及為您量身打造的個性化優惠！',
    orderNow: '立即下单',
    hours: '營業時間',
    location: '門市地點',
    contact: '聯絡方式',
    socials: "社群媒體",
    snappyWhy: '為什麼選擇 Snappy',
    snappyBlog: '部落格',
    snappyPricing: '價格',
    snappyDemo: '預約展示',
    snappyCaseStudies: '客戶案例',
    clickToRedeem: '點擊兌換',
    apply: '使用優惠券',
    order: '點餐',
    sortByDistance: '按距離排序',
    sortByAlpha: '按字母排序',
    searchLocations: '搜尋地點',
    az: '字母',
    nearest: '最近',
    atLeast: '最少',
    to: '-',
    takeout: '外賣',
    or: '或者',
    guest: '直接下單',
    back: '後退',
    other: '其他',
    poweredBy: 'POWERED BY',
    firstName: '名',
    lastName: '姓',
    phone: '電話',
    phoneNumber: '電話號碼',
    address: '地址',
    storeHours: '營業時間',
    onlineOrderAvailableUntil: '網上訂餐截止時間',
    mobileNumber: '手機號碼',
    groups: '組別',
    options: '選項',
    edit: '自定義',
    register: '註冊',
    status: '狀態',
    points: '積分',
    balance: '餘額',
    save: '保存',
    changesSaved: '更改已保存',
    cancel: '取消',
    confirm: '確認',
    message: '信息',
    loadMore: '加載更多',
    loading: '加載中...',
    expires: '有效日期',
    login: '登入 / 註冊',
    tweet: '發推',
    share: '分享',
    continue: '繼續',
    resend: '({0}秒後再次發送)',
    newCode: '新驗證碼',
    logout: '註銷',
    fillFields: '請填寫所有必填信息',
    invalidEmail: '電子郵箱格式錯誤',
    verify: '校驗',
    verifyCode: '驗證碼',
    sixDigitCode: '6位驗證碼',
    unlimited: '無上限',
    upTo: '最多',
    selected: '已選',
    items: '種',
    amount: '金額',
    scanQRCode: '請掃二維碼',
    loadingQRScanner: '加載攝像頭...',
    reloadQRScanner: '重新加載',
    open: '營業',
    open2: '正在營業',
    closed: '休息',
    closed2: '休息中',
    email: '電子郵箱',
    select: '選擇',
    ok: '確定',
    okConfirm: "確定",
    off: '折扣',
    app: {
      text1: '在',
      text2: 'App中打開',
      btn: '打開'
    },
    captcha: {
      main: 'This site is protected by reCAPTCHA and the Google',
      privacy: 'Privacy Policy',
      and: 'and',
      terms: 'Terms of Service',
      apply: 'apply.'
    },
    disclaimer: {
      main: '通過登入，我同意<link-tos>服務條款</link-tos>和<link-pp>隱私政策</link-pp>。我同意接收來自{businessName}的簡訊和其他數字通信，包括優惠券、特別優惠和促銷活動。可能會產生標準簡訊和數據費用。',
      register: '请点击 REGISTER 确认您同意Snappy的<link-tos>服务条款</link-tos>与<link-pp>隐私政策</link-pp>。Snappy将试用短信进行您的账户身份验证和信息通知。您可以随时取消短信服务。'
    },  
    addedToCart: 'Added "{0}" to cart',
    yourOrderId: '您的訂單號是'
  },
  hours: {
    twentyFourHours: '全天營業',
    midNight: '午夜',
    mon: "星期一",
    tues: "星期二",
    wed: "星期三",
    thurs: "星期四",
    fri: "星期五",
    sat: "星期六",
    sun: "星期日",
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    sunday: "星期日"
  },
  menu: {
    specialRequests: '特殊要求',
    required: '必選',
    optional: '可選',
    soldOut: '已售罄',
    selectMenu: '請選擇菜單',
    menuTitle: '菜單',
    promotionsAndRewards: '優惠與獎勵',
    categories: '分類',
    noMenu:  '本店沒有菜單',
    dropdown: '選單下拉',
    unavailable: 'Menu unavailable',
    available: '下單時間',
    dayAvailable: 'Next available',
    availableOffHours: '支持提前下單',
    menuIsExclusive: '不同菜單中的產品不能加到同一購物車中',
    item: {
      onlyAvailable: '可用的',
      available: 'This item is only available from {0} - {1}',
      prepTime: '此商品通常需要约{0}来准备'
    },
    menuAvailability: '菜單可用性',
    gotIt: "知道了！",
    onlyAvailable: '此菜單僅在特定時間提供：',
    pricingBanner: '直接從 {2} 訂購，與 {1} 相比平均可節省高達 {0}%'
  },
  cart: {
    title: '購物車',
    startShopping: '開始購物',
    continue: '繼續',
    serviceFee: '服務費',
    takeOutOrder: '外賣',
    backToLogin: '返回登錄',
    enterYourAddress: '請輸入您的地址',
    startAdding: '請添加您想要的商品',
    buildOrder: "請繼續添加商品",
    currentlyClosed: '未到營業時間，請稍後再來',
    delivery: '配送',
    pickup: '自取',
    dinein: '堂食',
    estTimeHours: '小時',
    estTimeMins: '分鐘',
    subtotal: '小計',
    deliveryFee: '配送費',
    tbd: '待定',
    deliveryMinimum: '配送最低消費',
    pickupMinimum: '自取最低消費',
    tax: '稅',
    tip: '小費',
    rewards: '積分獎勵',
    total: '總額',
    tipDriver: '配送司機小費',
    tipStore: '門店小費，感謝您的支持',
    btnCheckout: '結賬付款',
    addToCart: '加入購物車',
    aiRecommendationsTitle: '為您推薦',
    aiRecommendationsTitleGuest: '推薦',
    aiRecommendationsSubtitle: '根據您的訂單',
    aiRecommendationsSubtitleGuest: '本店熱銷',
    aiRecommendationsFrom: '起',
    clickToSee: '點擊查看選項',
    saveCartItem: '更新購物車',
    payWithMembership: '會員卡支付',
    btnSubmitSubOrder: '發送訂單',
    processing: '正在處理您的訂單',
    pastOrders: '訂單記錄',
    discount: '折扣',
    closeModal: '關閉',
    btnPayOrder: '發送訂單',
    cartUnavailable: '您的購物車中有些商品由於衝突或無效的可用性而無法訂購',
    storeUnavailable: '暫時無法加入購物車',
    storeClosedBtn: '門店已打烊',
    offHourOrderingMaybeAllowed: '商店目前已關閉，但您仍然可以預約稍後的訂單。',
    advanceBookingWindow: '商店已營業但暫未接受訂單，您可以預約稍後的訂單。',
    deliveryUnavailable: '目前無法配送',
    pickupUnavailable: '目前無法自取',
    tooSmallForDelivery: '未達到配送最低消費要求（最低消費：{0})',
    tooSmallForPickup: '訂單金額過少，無法取貨 (最低消費：{0})',
    invalidCoupon: '無效優惠券',
    cartErrors: '購物車錯誤',
    removeInvalidItemToContinue: '請移除該商品以繼續。',
    discountNotUsed: '購物車不得為空',
    deliveryDisabled: '商家暫時不接受配送',
    pickupDisabled: '商家暫時不接受自取',
    deliveryDisabledUntil: '配送暫停接單，將在 {0} 重新開放',
    pickupDisabledUntil: '自取暫停接單，將在 {0}重新開放',
    asapClosed: '已打烊 · {0} {1}開始營業',
    asapPastCutoff: '今日已停止接單',
    asapSuspendedToday: '今日已停止接單',
    storeStoppedAcceptingOrders: '您結帳時商家已停止接單。請選擇一個預約時間以繼續。'
  },
  account: {
    accountInfo: '賬戶信息',
    orderHistory: '歷史記錄',
    paymentMethods: '付款方式',
    contactInfo: '聯繫信息',
    membershipInfo: '會員信息',
    member: '會員',
    nonMember: '非會員',
    creditCard: '信用卡',
    nameOnCard: '姓名（請使用英文字母）',
    cardNumber: '卡號',
    expires: '有效日期',
    cvc: 'CVC',
    mmyy: '月/年',
    country: '信用卡所屬國家',
    saveCard: '保存信用卡',
    addPaymentMethod: '添加信用卡',
    deliveryDetails: '配送詳情',
    noOrderHistory: '沒有歷史記錄',
    noPaymentMethods: '沒有支付方式',
    addPaymentMethodPrompt: '請添加支付方式',
    noCreditCards: '沒有支付方式',
    otherPostalCode: '非美國或加拿大卡，請任意輸入',
    membership: '會員',
    history: '歷史',
    payments: '付款',
    offline: '線下支付',
    orderId: '訂單號',
    editTitle: '編輯個人信息',
    payment: {
      title: '刪除信用卡',
      body: '您確定要刪除此信用卡嗎?',
      cancel: '取消',
      delete: '刪除',
      status: {
        cvcFailed: '無效CVC',
        postalCodeFailed: '無效郵政編碼',
        expiredCard: '卡已過期'
      }
    },
    rewards: {
      redeemFor: '兌換',
      rewardOptions: '兌換選項',
      coupons: '優惠券',
      punchCards: '打孔卡',
      using: '使用',
      remaining: '剩餘',
      free: '免費',
      purchases: '已購買',
      redeem: '兌換',
      max: '上限',
      points: '積分',
      credits: 'Credits',
      discount: '折扣',
      yourPoints: '查看積分',
      creditsEarned: '獲得{0}',
      worth: '價值',
      insufficientFunds: '積分不足',
      removeFirst: '無法添加，請移除當前兌換獎勵',
      punchCardRibbon: '距離{2}還差{0}{1}！ ',
      selectItem: '選擇商品',
      availableInCart: '請在購物車中兌換積分',
      availableInCartUpdated: '在購物車中兌換此優惠',
      alreadyInCart: '{0} 已在購物車中',
      missingPoints: '再積{0}分即可兌換免費禮品！ ',
      inEligible: '您無法使用此優惠券',
      noExpiration: '無過期時間',
      noLimitation: '無限制',
      buy1Get1Free: '買一送一',
      buy1Get1PercentOff: '買一第二件 {0}% 折扣',
      buy1Get1AmountOff: '買一第二件減 ${0}',
      validForSelectItems: '適用於特定商品',
      discountPercentOff: '折扣 {0}% 優惠',
      discountAmountOff: '折扣 {0}{1} 優惠',
      discountOff: '折扣 {0} 優惠',
      discountUpTo: '{0}，最高 {1}',
      maxDiscountReached: '已達到最高折扣 {0}',
      maxDiscountOf: '最高 {0}',
      maxDiscountOfDetail: '最高折扣 {0}',
      offerExpires: '優惠到期：{0}',
      loginPrompt: '請登錄後查看積分',
      inPersonRedeemable: '此優惠只能在線下門店兌換',
      orderRewards: {
        congrats: '恭喜！ ',
        coupons: '您的訂單獲得了獎勵優惠卷',
        lossFallback: '抱歉，這次沒有中獎，下次再來一單！ '
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: '為您推薦',
    aiRecommendationsCategoryGuest: '推薦',
    deliveryProvider: {
      robot: '機器人',
      human: '司機',
      byRobot: '您的訂單將由機器人配送！ ',
      byHuman: '您的訂單將由司機配送',
      recommended: '商家推薦',
      notSupported: '您的地址不支持{0}配送', //where 0 is either Robot or Human
      deliveryInstructions: 'Please be aware, Robots cannot climb stairs. You will need to provide your emailed code in order to retrieve your food'
    },
    error: {
      empty: '這裡什麼也沒顯示!',
      noResults: '沒有返回結果.',
      tryAdjusting: '嘗試調整您的過濾器',
      clear: '清除搜尋'
    }
  },
  order: {
    estimatedTime: '您的訂單已經成功提交，大約{0}後可取',
    estimatedTimeDiff: '您的訂單已經成功提交，大約{0}分鐘後可取',
    successfulOrder: '您的訂單已經成功提交',
    deliveryAddressInvalid: '您輸入的地址信息無效，請重新輸入',
    deliveryAddressMustBeSet: '請輸入您的配送地址',
    deliveryAddressMustBeInRange: '對不起，您的地址不在配送範圍內，請聯繫門店下單',
    noPaymentMethodSelected: '請選擇支付方式',
    insufficientPoints: '會員充值餘額不足',
    requiresAdditionalMethod: '會員餘額不足，請添加第二種付款方式',
    cardMinimumCharge: '刷卡金額至少需 {0}。請新增小費或其他商品，或使用信用卡支付此訂單。',
    minCardChargeNote: '最低刷卡金額 {0}',
    applyMembershipInstead: '改為使用 {0}',
    noPaymentMethods: '請選擇付款方式',
    pickUpDetails: '自取詳情',
    orderDetails: '訂單詳情',
    selectOrderType: '請選擇訂單類型',
    orderPlaced: '已發送訂單',

    orderNotes: '訂單註解',
    pickUpTime: '自取時間',
    pickUpDay: '自取日期',
    deliveryTime: '配送時間',
    deliveryDay: '配送日期',
    deliveryAddress: '配送地點',
    addressLine1: '地址欄第一行',
    addressLine2: '地址欄第二行',
    postalCode: '郵編',
    city: '城市',
    payment: '支付',
    placeOrder: '發送訂單',
    personalDetails: '個人詳情',
    tableNumberSet: '桌號掃碼成功',
    onlyOffline: "本餐廳只接受線下支付",
    paidOffline: "請在線下進行支付",
    emailReceipt: "發送收據到我的郵箱",
    offlineEmailReceipt: "發送訂單詳情到我的郵箱",
    orderScheduled: "預訂時間",
    status: {
      new: '新單',
      inProgress: '準備中',
      ready: '已準備好',
      cancelled: '已取消',
      refunded: '已退款',
      completed: '完成'
    },
    orderActions: {
      call: '致電',
      direction: '導航',
      orders: '查看訂單',
      feedbackTitle: '請評價您的點餐體驗',
      feedbackLabel: '請留下您的寶貴意見'
    }
  },
  iosBanner: {
    partOne: '點擊分享圖標',
    partTwo: '選擇添加到主頁',
    partThree: '保存頁面'
  },
  checkoutSuccess: {
    text: '訂單成功'
  },
  orderSubmitted: {
    text: '訂單已提交'
  },
  deliveryDialog: {
    title: '配送詳情',
    deliverAsap: '立即配送',
    schedule: '預約',
    update: '更新',
    selectAddress: '請輸入您的地址',
    noDeliveryProviders: '該地址暫無配送服務',
    deliveryAddressSet: '配送地址已設置！',
    selectDateTime: '請選擇有效的日期和時間',
    notAvailable: '抱歉，此選項不可用',
    pleaseSelectDate: '請選擇日期'
  },
  orderDialog: {
    title: '取餐詳情',
    deliveryTitle: '配送詳情',
    pickUpAsap: '立即取餐',
    deliverAsap: '立即配送',
    schedule: '預約',
    done: '完成',
    selectDate: '請選擇日期',
    notAvailable: '抱歉，此選項不可用',
    selectDateTime: '請選擇有效的日期和時間',
    noAvailableDays: "没有可用的日期",
    earliestDate: "最早的日期已設定",
    staleTimeBodyGroup: "商店無法在{0}前準備好您的訂單。請選擇新時間以繼續 — 您的群組和訪客的商品不會改變。",
    staleTimeBodySolo: "商店無法在{0}前準備好您的訂單。請選擇新時間以繼續。",
    confirmSlot: "確認 {0}",
    goBack: "返回"
  },
  storeLocation: {
    pickUpAt: '取餐',
    inStore: '店內',
    pickUpTime: '取餐時間',
    deliveryTime: '配送時間',
    time: '時間',
    deliverTo: '配送至',
    clickToSet: '點擊設置'
  },
  orderTypes: {
    pickup: '自取',
    delivery: '配送',
    dineIn: '內用'
  },
  groupOrder: {
    title: '拼單',
    namePlaceholder: '拼單名稱',
    from: '來自',
    deliverTo: '配送至',
    pickupAt: '取餐地點',
    invitePeople: '邀請成員',
    chooseWhoPays: '選擇付款方式',
    paySubtitle: '發起人（您）將支付整個拼單的費用。付款方式將在結帳時填寫。',
    youPayForEveryone: '由您代付',
    hostWillPayForEveryone: '主辦人將代付',
    limitPlaceholder: '輸入每人限額（可選）',
    perPerson: '每人',
    everyonePaysThemselves: '各自付款',
    comingSoon: '即將推出',
    next: '下一步',
    yourGroupOrderLink: '您的拼單連結',
    copy: '複製',
    share: '分享',
    linkCopied: '連結已複製！',
    join: '加入 {0} 的拼單',
    spendingLimit: '消費限額',
    limitNoLimit: '無限制',
    limitOther: '其他',
    joinGroupOrder: '加入拼單',
    joining: '正在加入...',
    loginToJoin: '登入後加入',
    continueAsGuest: '以訪客身份繼續',
    enterYourName: '請輸入您的姓名',
    joinOrderDisclaimer: '點擊「加入訂單」即表示您同意',
    joinOrder: '加入訂單',
    back: '返回',
    notSet: '未設定',
    cancelGroupOrder: '取消拼單',
    cancelGroupOrderConfirmTitle: '取消 {0}？',
    cancelGroupOrderConfirmBody: '這將結束所有人的拼單，所有參與者將被移除。',
    cancelGroupOrderConfirm: '是的，取消',
    cancelGroupOrderKeep: '保留拼單',
    cartMenuCancelGroup: '取消拼單',
    cartMenuLeaveGroup: '退出',
    cartMenuInvite: '邀請成員',
    lockedBannerGuest: '此拼單已鎖定，如需修改請聯繫發起人。',
    lockedBannerHost: '您的購物車已鎖定，仍可繼續結帳。',
    unlockMyCart: '解鎖購物車',
    othersInGroup: '同組其他人（共 {0} 人）',
    othersHaveAdded: '{0} / {1} 人已新增商品',
    memberHostLabel: '（發起人）',
    memberReadyBadge: '已準備',
    memberWaitingBadge: '等待中',
    memberErrorBadge: '商品缺貨',
    memberCartHasErrors: '您的小組中有人的商品缺貨，請移除後再繼續。',
    memberNoItems: '暫無商品',
    unlockMemberCart: '解鎖 {0} 的購物車',
    removeMember: '移除 {0}',
    yourItems: '您的商品',
    leaveConfirmTitle: '退出此拼單？',
    leaveConfirmBody: '您的商品將被移除，發起人將收到您退出的通知。',
    leaveConfirmBtn: '退出',
    leaveConfirmKeep: '取消',
    removeConfirmTitle: '將 {0} 從拼單中移除？',
    removeConfirmBody: '{0} 的商品將被移除，他們將收到被移除的通知。',
    removeConfirmBtn: '移除 {0}',
    checkoutConfirmTitle: '大家都準備好了嗎？',
    checkoutConfirmBody: '繼續後，拼單將被鎖定，所有人將無法再做修改。',
    unreadyConfirmTitleSingle: '{0}還在下單',
    unreadyConfirmTitleMulti: '{0}位成員還在下單',
    unreadyConfirmBody: '結帳後將為所有人關閉訂單。',
    unreadyConfirmWaitingOnPrefix: '正在等待',
    unreadyConfirmWaitingOnSuffix: '。',
    and: '和',
    andOthers: '和另外 {0} 人',
    checkoutWithCurrentBtn: '連同他們的購物車結帳',
    checkoutWithCurrentSubtext: '訂單將包含他們目前已新增的商品',
    removeCartsCheckoutBtn: '不含他們結帳',
    removeCartsCheckoutSubtext: '他們的購物車和商品將從訂單中移除',
    errorRemoveUnreadyCarts: '部分購物車移除失敗，請重試。',
    groupCartEmpty: '請至少新增一件商品後再結帳。',
    participantWaiting: '等待中...',
    notReadyCount: '還有 {0} 位參與者未準備好',
    goToCheckout: '前往結帳',
    lockedInGroupOrder: '您正在拼單中——訂單類型和時間無法更改。',
    checkoutProcessing: '處理中...',
    checkoutBackBtn: '返回',
    readyBtn: '已準備好！',
    readyHint: '發起人將為所有人下單。',
    readyStatus: '已準備好！',
    imReadyBtn: '我準備好了！',
    addItemsBtn: '新增商品',
    lockedCheckoutBtn: '拼單已鎖定',
    lockedTimeoutBtn: '訂單已鎖定——時間到',
    exceedsLimit: '超出拼單限額',
    snackParticipantLeft: '{0} 已退出拼單。',
    errorMarkReady: '標記準備失敗，請重試。',
    errorCartLocked: '發起人已鎖定訂單，您現在無法修改。',
    errorUnlockCart: '無法解鎖購物車，請重試。',
    errorLockGroup: '鎖定拼單失敗，請重試。',
    errorLeaveGroup: '退出拼單失敗，請重試。',
    errorCancelGroup: '取消拼單失敗，請重試。',
    errorUnlockMember: '解鎖購物車失敗，請重試。',
    errorRemoveParticipant: '移除參與者失敗，請重試。',
    dialogRemovedTitle: '您已被移除',
    dialogRemovedBody: '發起人已將您從此拼單中移除，您的商品已清空。',
    dialogLeftTitle: '您已退出 {0}',
    dialogLeftBody: '您的商品已清空。',
    dialogCancelledTitle: '拼單已取消',
    dialogCancelledBody: '發起人已取消此拼單。',
    dialogPaidTitle: '下單成功！',
    dialogPaidBody: '您的拼單已成功提交。',
    dialogRecoveredTitle: '您有一個進行中的拼單',
    dialogRecoveredHost: '您是發起人',
    dialogRecoveredGuest: '您是參與者',
    dialogRecoveredBtn: '繼續',
    deadlineTitle: '設置截止時間',
    deadlineSubtitle: '大家需要在什麼時候完成點餐？',
    deadlineDayLabel: '截止日期（日）',
    deadlineTimeLabel: '截止時間（時）',
    noDeadline: '無截止時間',
    noDeadlineSet: '未設置截止時間',
    deadlineSpecificTime: '特定時間',
    orderDeadline: '點餐截止時間',
    orderBeforeDeadline: '請在 {0} 前下單',
    peopleCanOrderAnytime: '大家可以隨時點餐',
    notAvailableScheduled: '此預定時間不可用',
    deadlineNotAvailableNow: '配送時間設為「立即」時不可設置截止時間。',
    noAvailableDeadlineTimes: '沒有可用的截止時間，請選擇更晚的配送時間。',
    noSpendingLimit: '無消費限額',
    spendingLimitValue: '{0} 消費限額',
    dialogChangedTitle: '主持人已更新訂單',
    dialogChangedToDelivery: '已更改為外送',
    dialogChangedToPickup: '已更改為自取',
    dialogChangedTime: '時間已從 {0} 更改為 {1}',
    dialogChangedTimeSet: '預定時間設置為 {0}',
    dialogChangedTimeCleared: '預定時間已取消（盡快）',
    timeChangedLabel: '時間已更改',
    timeChangedToLabel: '時間更改為',
    confirmChangeToDelivery: '切換到外送？',
    confirmChangeToPickup: '切換到自取？',
    confirmChangeTypeBody: '這將為組內所有人更新訂單類型。',
    asap: '盡快',
    orderAsap: '立即下單',
    now: '現在',
    staleTimeTitle: '您選擇的時間已無法使用',
    staleTimeNearestSlotLabel: '最接近的可用時間',
    staleTimeChooseAnother: '選擇其他時間',
    errorResetSchedule: '更新時間失敗，請重試。',
    errorUpdateSchedule: '更新時間失敗，請重試。',
    errorUpdateScheduleConflict: '暫時無法更新，請查看後重試。',
    discountsAtCheckout: '結帳時套用折扣',
    deliveryFeeAtCheckout: '結帳時計算',
    feesCalculatedAtCheckout: '稅金、服務費及折扣將於結帳時計算',
    exceedsSpendingLimit: '此商品將超過發起人設定的消費上限。',
    cartFinalized: '您的拼單已完成，無法再新增商品。',
    noDeadlineSlots: '沒有可用的時段來設定截止時間。',
    errorUpdateDeadline: '無法更新截止時間，請重試。',
    deadlineUpdated: '訂單截止時間已更新：{0}',
    deadlineRemoved: '訂單截止時間已更新。',
    shareGroupOrder: '加入我的拼單！',
    memberLocked: '已鎖定',
    snackParticipantLeftHost: '{0} 已退出拼單。',
    tooltipBadgeNew: '新功能',
    tooltipTitle: '拼單如何使用',
    tooltipScene1Caption: '從菜單頁面發起拼單',
    tooltipScene2Caption: '設定截止時間——以及由誰付款',
    tooltipScene3Caption: '分享連結，或讓朋友掃描加入',
    tooltipScene4Caption: '所有人加入同一個購物車，一次結帳。',
    tooltipStartBtn: '發起拼單',
    tooltipGotItBtn: '知道了',
    tooltipDemoPeopleJoined: '{0} 人已加入',
    tooltipDemoDeadlineTimeExample: '7月10日週五 · 下午12:30',
    tooltipDemoPaySub: '你付款 · 每人限額 $15',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: '拼單購物車',
    tooltipDemoOneCheckout: '一次結帳——你付款',
    sheetTitle: '團體訂購上線囉',
    sheetSubtitle: '一起點餐——共用一個購物車，一次結帳。',
    sheetBullet1: '設定訂單截止時間',
    sheetBullet2: '你付款——或設定消費限額',
    sheetBullet3: '透過連結或 QR Code 邀請好友',
    sheetNotNowBtn: '暫時不要',
    showHowItWorks: '看看怎麼運作',
    hostSetsTip: '作為發起人，你來設定整個團體訂購的小費。',
    checkoutErrorGeneric: '結帳失敗，請重試。',
    checkoutErrorInvalidCart: '購物車中有部分商品需要處理後才能結帳。',
    checkoutErrorOutOfStock: '部分商品已售罄，請移除後重試。',
    checkoutErrorMissingSelection: '請檢查購物車中某項商品的選項。',
    checkoutErrorInvalidItem: '購物車中有一項商品已失效，請移除後重試。',
    checkoutErrorPaymentDeclined: '您的信用卡被拒絕，請嘗試其他付款方式。',
    checkoutErrorPaymentFraud: '發卡機構拒絕了此付款方式，請嘗試其他付款方式。',
    checkoutErrorCardDetails: '信用卡資訊有誤，請檢查後重試。',
    checkoutErrorCardExpired: '此信用卡已過期，請嘗試其他付款方式。',
    checkoutErrorPaymentGateway: '無法處理付款，請重試。',
    checkoutErrorNotOpen: '此團體訂購已不再開放。',
    checkoutErrorVersionConflict: '結帳過程中團體訂購發生了變化，請檢查後重試。',
    checkoutErrorInProgress: '結帳正在處理中。',
    checkoutErrorEmpty: '團體購物車是空的。',
    checkoutErrorBlocked: '還有參與者尚未準備好。',
  },
  weChat: {
    warning: '請您退出頁面，用微信掃碼掃描二維碼，謝謝',
    title: '請輸入桌號'
  },
  checkout: {
    addCoupon: '添加優惠券',
    couponCode: '優惠券代碼',
    title: '發送訂單',
    description: '請確認下單',
    confirmCancel: '稍等',
    confirmApprove: '確認',
    onlinePay: '在線支付',
    weChatPay: '微信支付',
    unitNumber: '門牌號（選填）',
    primaryMethod: '支付',
    secondaryMethod: ' 第二種付款方式',
    credits: '賬戶餘額',
    orderHints: '例如：任何忌口',
    deliveryHints: '例如：配送後請按門鈴，請放在門廊，公寓buzz號碼等',
    deliveryOptions: '配送說明',
    deliveryInstructions: '配送方式',
    orderDisposables: '需要一次性餐具、吸管等用品',
    deliveryDisposables: '請提供一次性餐具',
    disposablesIncluded: '如果您沒有選擇將不會提供',
    noPaymentMethods: '沒有可用的付款方式<br>請聯繫 {0}',
    billLoadError: '無法載入您的訂單總額，請重試。',
    applePayFailed: '無法啟動 Apple Pay，請重試或選擇其他付款方式。',
    retry: '重試',
    confirmDialog: {
      total: '總',
      name: '門店名稱',
      location: '門店地址',
      deliveryInfo: '配送信息',
      deliveryAddress: ' 配送地址',
      deliveryPhone: '配送電話',
      scheduled: '預約時間',
      pay: '支付',
      pickupTitle: '到店自取嗎？',
      pickupBody: '請確認您將到店自取此訂單。',
      pickupTime: '取餐時間：',
      beforeYouArrive: '到店前須知',
      yesPickUp: '是，我要取餐',
      goBack: '返回'
    },
    deliveryMessage: {
      leave_at_door: '放在門前',
      meet_at_door: '在門口見面',
      meet_outside: '在外面見面'
    },
    couponTypes: {
      title: '由於您使用了優惠券，此訂單只能通過以下方式支付：',
      membership: '賬戶餘額',
      online: '信用卡',
      wechat: '微信支付',
      offline: '線下支付'
    }
  },
  qr: {
    manulInput: '如無法掃碼，請輸入您的桌號',
    selectTable: '桌號',
    select: '確認'
  },
  apps: {
    giftcard: '禮品卡',
    coupons: '購買優惠券',
    deposit: '充值',
    lineup: '等候名單',
    reservation: '預約'
  },
  requestService: {
    openButton: '呼叫服務',
    title: '選擇請求發送給服務員',
    sent: '請求已發送',
    login: '您需要在登錄後使用此功能',
    tableNeeded: '請輸入您的桌號以使用此功能'
  },
  sharedCart: {
    bannerLabel: '共享餐桌 · 桌號 #{0}',
    live: '即時',
    staleItemWarning: '其他顧客已更新 — 請確認後儲存',
    sentToKitchen: '已送至廚房',
    roundSentToKitchen: '第 {0} 輪 · 已送至廚房',
    alreadyOrdered: '已點餐',
    itemCount: '{0} 項',
    stillOrdering: '正在加點',
    sending: '傳送中...',
    reconnected: '已重新連接到共享餐桌 {0}。',
    joinedTitle: '您已加入餐桌！',
    joinedBody: '您現在正在與這裡的所有人共享此餐桌的訂單。',
    completedTitle: '餐桌訂單已付款！',
    completedBody: '此餐桌的付款已完成，謝謝！',
    billAtPosTitle: '帳單已發送至收銀台',
    billAtPosBody: '您餐桌的帳單已發送至收銀台，請在那裡付款以完成訂單。',
    cancelledTitle: '餐桌工作階段已結束',
    cancelledBody: '此餐桌的共享購物車工作階段已過期，請掃描 QR 碼開始新的工作階段。',
    roundFired: '餐點已傳送到廚房。',
    errorFireRound: '傳送到廚房失敗，請重試。',
    errorItemChanged: '其他人已變更此商品 — 已重新整理為最新版本，請重試。',
    errorMutateCart: '操作未成功，請重試。',
    errorSessionClosed: '此餐桌已關閉。',
    sharedTable: '共享餐桌',
    sharedTableActive: '● 共享餐桌進行中',
    tableLabel: '餐桌 {0}',
    errorStartSharedTable: '無法開始共享餐桌，請重試。',
  },
}
